import type { AdminDocumentResponse } from '../../api/types';

/**
 * What a document belongs to (#282, rhino-api R33): a shipment, or — for renewed vehicle insurance and
 * fitness — a vehicle with no shipment. Screens use it so no link ever points at /shipments/null.
 */
export type DocumentSubject =
  | { kind: 'shipment'; shipmentId: number }
  | { kind: 'vehicle'; label: string }
  | { kind: 'none' };

export function documentSubject(
  d: Pick<AdminDocumentResponse, 'shipmentId' | 'vehicleId' | 'registrationNumber'>,
): DocumentSubject {
  if (d.shipmentId != null) return { kind: 'shipment', shipmentId: d.shipmentId };
  if (d.registrationNumber) return { kind: 'vehicle', label: `Vehicle ${d.registrationNumber}` };
  if (d.vehicleId != null) return { kind: 'vehicle', label: `Vehicle #${d.vehicleId}` };
  return { kind: 'none' };
}
